<template lang='pug'>
    r-dialog( 
        content-class='grey lighten-3'
        no-confirm
        ref='dialog'
        v-bind='dialogComputed' 
        v-model='_value' 
    )
        r-form( 
            class='white'
            ref='form'
            v-bind='formProps' 
            v-model='formData'
            @submit='submit'
        )
</template>

<script>
    //
    import RDialog from '../crud-dialog'
    import RForm from '../model-form'
    //
    export default {
        components: {
            RDialog,
            RForm,
        },
        computed: {

            /**
             * 
             */
            dialogComputed() {
                return {
                    ...this.dialogProps,
                    title: this.title,
                }
            },

            /**
             * @description
             * if has model
             */
            hasModel() {
                return typeof this.model === 'function'
            },

            /**
             * @description
             * avoid value data
             */
            _value:{

                // get parent value
                get() {
                    return this.value
                },

                // set parent value
                set(value) {
                    this.$emit('input', value)
                },
            },
        },
        data() {
            return {
                formData: {},
            }
        },
        methods: {

            /**
             * 
             */
            async close() {
                this.$refs.dialog.close()
            },

            /**
             * 
             */
            emit(model) {
                this.$emit('success', model)
            },

            /**
             * 
             */
            fetch(event) {
                return this.model
                    .find(event[ this.modelKey ])
                    .then(this.mapper)
                    .then(this.emit)
            },

            /**
             * @description
             * init data
             */
            init() {
                if (this.hasModel) this.setFormData(this.model)
            },

            /**
             * @description
             * success submit
             */
            error(event) {
                this.methodError(event)
            },

            /**
             * @description
             * reset component
             */
            reset() {
                this.init()
            },

            /**
             * @description
             * set form data
             */
            setFormData(Model) {
                this.formData = new Model(this.resetData)
            },

            /**
             * @description
             * submit form
             */
            submit() {
                console.log('submit')
                this.wait(true)
                    .then(this.method)
                    .then(this.fetch)
                    .then(this.success)
                    .catch(this.error)
                    .then(this.wait)
            },

            /**
             * @description
             * success submit
             */
            success() {
                this.close().then(this.methodSuccess)
            },

            /**
             * @description
             * set wait form
             */
            wait() {
                return this.$refs.form.setWait(!this.$refs.form.wait)
            },
        },
        props: {
            /**
             * @description
             * dialog props
             */
            dialogProps: {
                type: Object,
                default: () => ({}),
            },

            /**
             * @description
             * dialog props
             */
            formProps: {
                type: Object,
                default: () => ({}),
            },

            /**
             * @description
             * method component
             */
            mapper: {
                type: Function,
                default: model => model,
            },

            /**
             * @description
             * method component
             */
            method: {
                type: Function,
                default: () => {},
            },

            /**
             * @description
             * error method component
             */
            methodError: {
                type: Function,
                default: () => {},
            },

            /**
             * @description
             * success method component
             */
            methodSuccess: {
                type: Function,
                default: () => {},
            },

            /**
             * @description
             * model component
             */
            model: Function,

            /**
             * 
             */
            modelKey: {
                type: String,
                default: 'id',
            },

            /**
             * @description
             * model initial data
             */
            resetData: {
                type: Object,
                default: () => ({}),
            },

            /**
             * @description
             * component title
             */
            title: {
                type: String,
                default: 'Agregar item',
            },

            /**
             * @description
             * dialog value
             */
            value: Boolean,
        },
        mounted() {
            this.reset()
        },
    }
</script>